import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {VideoChatPage} from './video-chat-page/video-chat.page';
import {VideoChatCompletePage} from './video-chat-complete/video-chat-complete.page';
import {CoachingSessionResolver} from '../../resolvers/coaching-session.resolver';

const routes: Routes = [
    {
        path: 'room/:sessionId',
        component: VideoChatPage,
        resolve: {
            sessionInfo: CoachingSessionResolver
        }
    },
    {
        path: 'complete',
        component: VideoChatCompletePage
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class VideoChatRoutingModule {
}
